module.exports = __webpack_public_path__ + "fonts/BarlowCondensed-SemiBold.e1d870b.woff2";